import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';

import { Patient } from '../entities/patient.entity';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root'
})
export class PairingService {

  private readonly GET_MY_PATIENTS_REQUEST_PATH = "/api/v1.1/pairing/getMyPatient";
  private readonly CREATE_REQUEST_PATH = "/api/v1.1/pairing/createRequest";
  private readonly ACCEPT_REQUEST_PATH = "/api/v1.1/pairing/acceptRequest";
  private readonly REJECT_REQUEST_PATH = "/api/v1.1/pairing/rejectRequest";
  private readonly REVOKE_REQUEST_PATH = "/api/v1.1/pairing/revokeRequest";
  private readonly DELETE_REQUEST_PATH = "/api/v1.1/pairing/deleteRequest";

  constructor(private webApiService: WebApiService) {}

  /**
   * Gets patients of logged user
   * @returns Observable with patients list
   */
  public getMyPatients(): Observable<Patient[]> {
    return this.webApiService.get(this.GET_MY_PATIENTS_REQUEST_PATH).pipe(
      map(response => response.data.map(item => new Patient().deserialize(item)))
    );
  }

  /**
   * Gets patient
   * @param id
   * @returns Observable with one patient
   */
  public getMyPatient(id: string): Observable<Patient> {
    return this.webApiService.get(this.GET_MY_PATIENTS_REQUEST_PATH + '/' + id).pipe(
      map(response => new Patient().deserialize(response.data))
    );
  }

  /**
   * Creates a pairing request
   * @param userId
   * @returns Observable
   */
  public createRequest(userId: string): Observable<any> {
    const data = {
      targetUserId: userId
    };

    return this.webApiService.post(this.CREATE_REQUEST_PATH, data);
  }

  /**
   * Updates pairing then accepts pairing request
   * @param pairingId
   * @returns Observable
   */
  public acceptRequest(pairingId: string): Observable<any> {
    return this.webApiService.put(this.ACCEPT_REQUEST_PATH + '/' + pairingId);
  }

  /**
   * Updates pairing then rejects pairing request
   * @param pairingId
   * @returns Observable
   */
  public rejectRequest(pairingId: string): Observable<any> {
    return this.webApiService.put(this.REJECT_REQUEST_PATH + '/' + pairingId);
  }

  /**
   * Updates pairing then revokes pairing request
   * @param pairingId
   * @returns Observable
   */
  public revokeRequest(pairingId: string): Observable<any> {
    return this.webApiService.put(this.REVOKE_REQUEST_PATH + '/' + pairingId);
  }

  /**
   * Deletes pairing request
   * @param pairingId
   * @returns Observable
   */
  public deleteRequest(pairingId: string): Observable<any> {
    return this.webApiService.delete(this.DELETE_REQUEST_PATH + '/' + pairingId);
  }

}
